const useListColumns = () => {
  return [
    {
      Header: "Title",
      accessor: "title",
    },
    {
      Header: "Date",
      accessor: "date",
      disableGlobalFilter: true,
      sortType: (rowA: any, rowB: any) => rowA.original._dateTs - rowB.original._dateTs,
    },
    {
      Header: "Created at",
      accessor: "createDate",
      disableGlobalFilter: true,
      sortType: (rowA: any, rowB: any) => rowA.original._createDateTs - rowB.original._createDateTs,
    },
    {
      Header: "Updated at",
      accessor: "updateDate",
      disableGlobalFilter: true,
      sortType: (rowA: any, rowB: any) => rowA.original._updateDateTs - rowB.original._updateDateTs,
    },
    {
      Header: "",
      accessor: "actions",
      disableSortBy: true,
      disableGlobalFilter: true,
    },
  ];
};

export default useListColumns;
